import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ModalFormUsuarioPlataforma({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();

    // useEffect(() => {
    //     iniciar();
    // }, [formData]);

    // const iniciar = async () => {
    //     try {
    //         console.log('formData');
    //         console.log(formData);
    //     } catch (err) {
    //         console.log('iniciar err');
    //         console.log(err);
    //     }
    // };

    const charLimits = {
        nombre: 64,
        apellido: 64,
        email: 128,
        telefono: 64,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            let message = "";
            if (String(formData.linea).trim().length === 0) {
                message = message + t("alert_must_enter_line") + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            nombre: "",
            apellido: "",
            email: "",
            telefono: "",
        });
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>

                        {/* Inputs */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_nombre")}</label>
                            <input
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                placeholder={t("enter_name")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_last_name")}</label>
                            <input
                                name="apellido"
                                value={formData.apellido}
                                onChange={handleInputChange}
                                placeholder={t("enter_last_name")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.apellido.length}/{charLimits.apellido}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">EMAIL</label>
                            <input
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                placeholder={"EMAIL"}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.email.length}/{charLimits.email}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_telefono")}</label>
                            <input
                                name="telefono"
                                value={formData.telefono}
                                onChange={handleInputChange}
                                placeholder={t("enter_telefono")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.telefono.length}/{charLimits.telefono}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
